import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { TextPrivate } from '../text/text.esm.js';

var _excluded = ["variant", "ellipsis", "__css"];
var Label = /*#__PURE__*/React.forwardRef(function Label(props, ref) {
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'label' : _props$variant,
    _props$ellipsis = props.ellipsis,
    ellipsis = _props$ellipsis === void 0 ? true : _props$ellipsis,
    _props$__css = props.__css,
    __css = _props$__css === void 0 ? {} : _props$__css,
    rest = _objectWithoutProperties(props, _excluded);
  return (
    /*#__PURE__*/
    //@ts-ignore
    React.createElement(TextPrivate, _extends({
      ref: ref,
      as: "label",
      variant: variant,
      ellipsis: ellipsis,
      __themeKey: "forms",
      __css: _objectSpread2({
        display: 'inline-block'
      }, __css)
    }, rest))
  );
});

export default Label;
//# sourceMappingURL=label.esm.js.map
